import React from "react";

class LazyLoadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inView: false
    };
  }

  componentDidMount() {
    if (this.node.getBoundingClientRect().top <= window.innerHeight) {
      this.setState({ inView: true });
    } else {
      if ("IntersectionObserver" in window) {
        this.onScrollWithIntersectionObserver();
      } else {
        if (this.state.inView === false) {
          document.addEventListener("scroll", this.onScrollFallBack);
          window.addEventListener("resize", this.onScrollFallBack);
          window.addEventListener("orientationchange", this.onScrollFallBack);
        }
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.onScrollFallBack);
    window.removeEventListener("resize", this.onScrollFallBack);
    window.removeEventListener("orientationchange", this.onScrollFallBack);
  }

  onScrollWithIntersectionObserver = () => {
    let that = this;
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          that.setState({ inView: true });
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });
    lazyBackgroundObserver.observe(this.node);
  };

  onScrollFallBack = () => {
    if (this.node.getBoundingClientRect().top <= window.innerHeight) {
      this.setState({ inView: true });
      document.removeEventListener("scroll", this.onScrollFallBack);
      window.removeEventListener("resize", this.onScrollFallBack);
      window.removeEventListener("orientationchange", this.onScrollFallBack);
    }
  };

  render() {
    const { children } = this.props;
    const childrenWithInViewProp = React.Children.map(children, child =>
      React.cloneElement(child, { inView: this.state.inView })
    );
    return <div ref={node => (this.node = node)}>{childrenWithInViewProp}</div>;
  }
}

export default LazyLoadImage;
